import React, {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {alreadyPaidPayCheck, payCheckDishes, translateRecord} from "./utils";

const PayCheckDishes = (props) => {
  const { t } = useTranslation();

  function dishParameter(dish, param) {
    if (param === 'weight') {
      return !!dish.weight ? `${dish.weight}${t(`measures.${dish['measure']}`)}` : '';
    } else if (param === 'quantity') {
      return Number.isInteger(parseFloat(dish.quantity)) ? parseInt(dish.quantity) : dish.quantity
    } else {
      return dish[param];
    }
  }

  const items = (payCheck) =>
    <>
      { Object.entries(payCheckDishes(payCheck)).map(([guestId, orders], index) => (
        <div key={index}>
          {Object.keys(payCheckDishes(payCheck)).length > 1 && <h5>Гість {parseInt(guestId)+1}</h5>}
          {orders.map((d, i) => (
            <div className="d-flex align-items-center justify-content-between order-dish" key={i}>
              <div className="d-flex align-items-center" style={{maxWidth: '66%'}}>
                <div className='ml-2'>
                  <h6 className="mt-0 mb-0">{translateRecord(d, 'name')}</h6>
                  <p className='text-muted mb-0 fs-12'>
                    {translateRecord(d, 'category')} {d.weight_flag && `| ${dishParameter(d.dish_variation || d, 'weight')}`} {!!d.dish_variation_id && `| ${translateRecord(d.dish_variation, 'name')}`}
                  </p>
                  { !!d.modifications &&
                  <p className='text-muted mb-1' style={{lineHeight: 1}}>
                    { d.modifications.map((m,i) =>
                      <span key={i} className='mr-1' style={{fontSize: 11}}>
                          {m.name}{m.quantity > 1 && <span className='text-primary'> x<b>{m.quantity}</b></span>}{d.modifications.length - 1 !== i && ','}
                        </span>)}
                  </p>}
                  <p className="text-muted mb-0 d-flex align-items-center">
                    <span className='mr-1 text-primary'>{dishParameter(d, 'price')}<small>₴</small></span>
                    { (dishParameter(d, 'quantity') > 1 || d.weight_flag) ?
                      <Button className='btn-primary' style={{padding: '0 3px', borderRadius: '3px'}}>
                        x<b>{dishParameter(d, 'quantity')}{d.weight_flag && !d.dish_variation_id ? t(`measures.${d['measure']}`) : ''}</b>
                      </Button>
                      : ''}
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <span style={{color: '#F99724'}}>
                  <b>{parseFloat(d.amount).toFixed(2)}<small>₴</small></b>
                </span>
              </div>
            </div>
          ))}
        </div>
      ))}
    </>;

  console.log('propsPayCheckDishes', props);

  return (
    <>
      { props.payCheck.child_pay_checks.length > 0 &&
        props.payCheck.child_pay_checks.every((c) => !!c.poster_id) ?
        <>
          { props.payCheck.child_pay_checks.map((check, i) =>
            <Fragment key={i}>
              <div className='d-flex align-items-center justify-content-between'>
                { !!check.user ?
                  <h5 className='text-center mb-0'>
                    {check.user.name}{!!check.invoice_url && ` - ${alreadyPaidPayCheck(check) ? t(`payCheckStatuses.${check.status}`) : t('components.menu.inPayProcess')}`}
                  </h5>
                :
                  <h5 className='text-center mb-0'>
                    {t('components.menu.person')} {i+1} {alreadyPaidPayCheck(check) && `- ${t(`payCheckStatuses.${check.status}`)}`}
                  </h5>}
                <h5 className='text-center mb-0 ml-1'>{check.amount}<small>₴</small></h5>
              </div>
              {items(check)}
            </Fragment>)}
        </>
      :
        <>{items(props.payCheck)}</>}
      {props.table.room.service_commission && !!props.table.room.commission &&
      <h6 className="mt-0">
        + {t('components.menu.commission')} {props.table.room.commission}%
      </h6>}
    </>
  );
};

export default PayCheckDishes;